export default __webpack_public_path__ + "static/media/arrow.0801cc9a.svg";